import { render, staticRenderFns } from "./StoreFooter.vue?vue&type=template&id=191b4aba&scoped=true&"
import script from "./StoreFooter.vue?vue&type=script&lang=js&"
export * from "./StoreFooter.vue?vue&type=script&lang=js&"
import style0 from "./StoreFooter.vue?vue&type=style&index=0&id=191b4aba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191b4aba",
  null
  
)

export default component.exports